import type { FirebaseOptions } from 'firebase/app'

const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyCv59Bt-9MptSeUniuw9Kk_9Oo4eNTlG34',
  authDomain: 'ecoplanet-1.firebaseapp.com',
  projectId: 'ecoplanet-1',
  storageBucket: 'ecoplanet-1.appspot.com',
  messagingSenderId: '771463006495',
  appId: '1:771463006495:web:780c9e32a409b558ff482a',
  databaseURL: 'https://ecoplanet-1-default-rtdb.europe-west1.firebasedatabase.app',
}

export { firebaseConfig }
